<template>
  <v-col class="pa-0">
    <div v-if="!creatingUser" class="pa-6">
      <v-row>
        <v-col cols="12" md="3">
          <v-row class="ma-0" justify="center" justify-md="start">
            <v-text-field
              class="input"
              label="Search..."
              prepend-inner-icon="mdi-magnify"
              rounded
              v-model="search"
              style="max-width: 300px"
            ></v-text-field>
          </v-row>
        </v-col>
        <v-col cols="12" md="3">
          <v-row class="ma-0" justify="center" justify-md="start">
            <v-select
              @change="setLastStatus"
              class="statusSelect input"
              style="max-width: 300px"
              label="Selected Status"
              rounded
              v-model="selectedStatus"
              :items="statusOptions"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-row>
        </v-col>
        <v-col cols="12" md="3">
          <v-row justify="center" justify-md="center">
            <VueJsonToCsv
              :json-data="exportData"
              :csv-title="'Users'"
              class="export-btn mt-6"
            >
            </VueJsonToCsv>
          </v-row>
        </v-col>
        <v-col cols="12" md="3" class="pa-6">
          <v-row
            v-if="storeUser"
            justify="center"
            justify-md="end"
            class="ma-0"
          >
            <v-btn
              @click="
                selectedUser = null;
                creatingUser = true;
              "
              color="#e022d1"
              dark
              rounded
              width="auto"
              class="pink-btn"
            >
              Create User
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-data-table
          no-data-text="No users yet"
          style="width: 100%"
          :headers="headers"
          :items="filteredUsers"
          :items-per-page="10"
          class="elevation-1 ml-4 mr-8"
        >
          <template v-slot:item.action="{ item }">
            <td>
              <v-icon
                color="#4390c0"
                @click="
                  selectedUser = item;
                  creatingUser = true;
                "
                >mdi-pencil</v-icon
              >
            </td>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              class="capatilize"
              :color="statusColor(item.status || 'pending')"
              dark
            >
              {{ item.status || "pending" }}
            </v-chip>
          </template>
        </v-data-table>
      </v-row>
    </div>
    <div v-if="creatingUser" class="pa-4">
      <HandleClient :user="selectedUser" @close="handleClose()" />
    </div>
    <v-row justify="center">
      <v-overlay :value="loading">
        <v-progress-circular
          :size="100"
          color="#4390c0"
          indeterminate
        ></v-progress-circular>
      </v-overlay>
    </v-row>
  </v-col>
</template>

<script>
import VueJsonToCsv from "vue-json-to-csv";

import HandleClient from "../components/HandleClient.vue";

import { auth } from "../../firebaseConfig.js";
import {
  signInWithEmailAndPassword,
  setPersistence,
  browserLocalPersistence,
  onAuthStateChanged,
} from "firebase/auth";
import {
  collection,
  getDocs,
  where,
  getFirestore,
  query,
  getDoc,
  doc,
  onSnapshot,
  addDoc,
} from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig";
const db = getFirestore(firebaseApp);

export default {
  data() {
    return {
      headers: [
        {
          text: "First Name",
          value: "firstName",
        },
        { text: "Surname", value: "lastName" },
        { text: "Email Address", value: "email" },
        { text: "Cell Number", value: "contact" },
        { text: "Address", value: "address" },
        { text: "Status", value: "status" },
        { text: "Action", value: "action" },
      ],
      creatingUser: false,
      users: [],
      search: "",
      selectedUser: null,
      loading: false,
      selectedStatus: "approved",
      statusOptions: [
        { text: "Pending", value: "pending" },
        { text: "On Hold", value: "on hold" },
        { text: "Approved", value: "approved" },
        { text: "Denied", value: "denied" },
        { text: "Email Unverified", value: "Email Unverified" },
      ],
      unsubscribeClientUsers: null,
    };
  },
  components: {
    HandleClient,
    VueJsonToCsv,
  },
  async mounted() {
    if (localStorage.getItem("LastViewedStatusType")) {
      this.selectedStatus = localStorage.getItem("LastViewedStatusType");
    }

    setTimeout(async () => {
      let res = await this.getUsers();

      if (localStorage.getItem("ViewedUser")) {
        let selectedUser = JSON.parse(localStorage.getItem("ViewedUser"));
        let newUser = this.users.find((user) => user.id == selectedUser.id);

        if (newUser) {
          this.selectedUser = newUser;
          this.creatingUser = true;
        }
      }
    }, 1000);
  },
  methods: {
    handleClose() {
      this.creatingUser = false;
      localStorage.removeItem("ViewedUser");
    },
    setLastStatus() {
      localStorage.setItem("LastViewedStatusType", this.selectedStatus);
    },
    updateSelectedType() {
      localStorage.setItem("lastViewedUserType", this.userType);
    },
    statusColor(status) {
      switch (status) {
        case "denied":
          return "#DC143C";
        case "pending":
          return "#4390c0";
        case "approved":
          return "green";
        case "on hold":
          return "grey";
        default:
          return "grey";
      }
    },
    isClientCompany(item) {
      return (
        item.userType == "Company" ||
        item.companyName ||
        item.practiceNumber ||
        item.companyId ||
        item.companyID
      );
    },
    getUsers() {
      try {
        const q = query(collection(db, "clients"));

        this.loading = true;

        // Subscribe to real-time updates
        this.unsubscribeClientUsers = onSnapshot(q, (querySnapshot) => {
          this.users = [];

          querySnapshot.forEach((doc) => {
            let tempUser = doc.data();
            tempUser.id = doc.id;

            if (!tempUser.status) {
              tempUser.status = "pending";
            }

            this.users.push(tempUser);
          });

          this.loading = false;
        });
      } catch (error) {
        this.loading = false;
        console.log("error: ", error);
      }
    },
  },
  beforeUnmount() {
    if (this.unsubscribeClientUsers) {
      this.unsubscribeClientUsers();
    }
  },
  computed: {
    filteredUsers() {
      return this.users.filter((item) => {
        if (this.isClientCompany(item)) {
          return false;
        }

        const matchesStatus =
          this.selectedStatus === "Email Unverified"
            ? item.emailVerified !== true
            : !this.selectedStatus || item.status === this.selectedStatus;

        const matchesSearch = Object.values(item).some((value) => {
          if (value !== null && value !== undefined) {
            return value
              .toString()
              .toLowerCase()
              .includes(this.search.toLowerCase());
          }
          return false;
        });

        return matchesStatus && matchesSearch;
      });
    },
    storeUser() {
      return this.$store.state.user || {};
    },
    exportData() {
      let objectList = [];
      let tempObject = {};

      if (this.filteredUsers) {
        this.filteredUsers.forEach((event) => {
          tempObject = {};

          if (this.userType == "Company") {
            tempObject.CompanyName = event.companyName;
            tempObject.PracticeNumber = event.practiceNumber;
            tempObject.City = event.city;
            tempObject.Province = event.province;
            tempObject.PostalCode = event.postalCode;
          } else if (this.userType == "Doctor") {
            tempObject.Name = event.name;
            tempObject.Surname = event.surname;
            tempObject.Profession = event.profession;
            tempObject.ClientPreference = event.clientPreference;
            tempObject.IDNumber = event.idNumber;
          } else {
            tempObject.Name = event.name;
            tempObject.Surname = event.surname;
            tempObject.IDNumber = event.idNumber;
          }

          tempObject.Email = event.email;
          tempObject.PhoneNumber = event.CellNo;
          tempObject.Address = event.address;

          objectList.push(tempObject);
        });

        return objectList;
      } else {
        return [{}];
      }
    },
  },
};
</script>

<style scoped></style>


